import { PackagedProductGetDTO } from 'svila-common';
import { PACKAGE_TYPES } from '../../utils/constants';
import { QuantitiesOfProduct } from '~/src/types/Misc';

class ProductService {
  static getTotalCu(products: PackagedProductGetDTO[], qdu: number, qcu: number, qdp: number): number | null {
    const du = this.getDu(products);
    const cu = this.getCu(products);
    const dp = this.getDisplay(products);
    let dudp = null;
    if (dp) {
      dudp = this.getDuOfDisplay(products);
    }

    if (cu == null || du == null || du.numberSmallerUnits == null) {
      return null;
    }

    let totalCu = qcu;
    if (dp != null && dudp != null && dudp.numberSmallerUnits != null) {
      totalCu += qdp * dudp.numberSmallerUnits;
    }

    totalCu += qdu * du.numberSmallerUnits;

    return totalCu;
  }

  static getTotalsFromCu(products: PackagedProductGetDTO[], qcu: number): QuantitiesOfProduct {
    const du = this.getDu(products);
    const cu = this.getCu(products);
    const dp = this.getDisplay(products);
    let dudp = null;
    if (dp) {
      dudp = this.getDuOfDisplay(products);
    }

    let availableCu = qcu;
    const quantities = {
      dus: 0,
      dps: 0,
      cus: 0,
    };

    if (du !== null && du.numberSmallerUnits !== null) {
      quantities.dus = Math.floor(availableCu / du?.numberSmallerUnits);
      availableCu = qcu % du?.numberSmallerUnits;
    }

    if (dp !== null && dudp && dudp.numberSmallerUnits !== null) {
      quantities.dps = Math.floor(availableCu / dudp?.numberSmallerUnits);
      availableCu = availableCu / dudp?.numberSmallerUnits;
    }

    quantities.cus = availableCu;

    return quantities;
  }

  static getCu(products: PackagedProductGetDTO[]): PackagedProductGetDTO | null {
    const cuPackage = products.find((item) => item.pack.type === PACKAGE_TYPES.CONSUMER_UNIT);

    if (!cuPackage) {
      return null;
    }
    return cuPackage;
  }

  static getDisplay(products: PackagedProductGetDTO[]): PackagedProductGetDTO | null {
    const displayPackage = products.find((item) => item.pack.type === PACKAGE_TYPES.DISPLAY);
    if (!displayPackage) {
      return null;
    }
    return displayPackage;
  }

  static getDu(products: PackagedProductGetDTO[]): PackagedProductGetDTO | null {
    const cuPackage = ProductService.getCu(products);
    if (!cuPackage) {
      return null;
    }
    const duPackage = products.find((item) => {
      if (item.pack.type === PACKAGE_TYPES.DISTRIBUTION_UNIT && item.smallerUnitId === cuPackage.id) {
        return item;
      }
      return null;
    });

    return duPackage ?? null;
  }

  static getDuOfDisplay(products: PackagedProductGetDTO[]): PackagedProductGetDTO | null {
    const displayPackage = products.find((item) => item.pack.type === PACKAGE_TYPES.DISPLAY);
    const duPackage = products.find(
      (item) => item.pack.type === PACKAGE_TYPES.DISTRIBUTION_UNIT && item.smallerUnitId === displayPackage.id,
    );
    if (!duPackage) {
      return null;
    }
    return duPackage;
  }

  static getCuId(products: PackagedProductGetDTO[]): string {
    const cuPackage = products.find((item) => item.pack.type === PACKAGE_TYPES.CONSUMER_UNIT);
    if (!cuPackage) {
      return '';
    }
    return cuPackage.id;
  }

  static getDuId(products: PackagedProductGetDTO[]): string {
    const cuPackage = products.find((item) => item.pack.type === PACKAGE_TYPES.CONSUMER_UNIT);
    const duPackage = products.find(
      (item) => item.pack.type === PACKAGE_TYPES.DISTRIBUTION_UNIT && item.smallerUnitId === cuPackage.id,
    );
    if (!duPackage) {
      return '';
    }
    return duPackage.id;
  }

  static getDisplayId(products: PackagedProductGetDTO[]): string {
    const displayPackage = products.find((item) => item.pack.type === PACKAGE_TYPES.DISPLAY);
    if (!displayPackage) {
      return '';
    }
    return displayPackage.id;
  }

  static getCuGtin(products: PackagedProductGetDTO[]): string {
    const cuPackage = products.find((item) => item.pack.type === PACKAGE_TYPES.CONSUMER_UNIT);
    if (!cuPackage || cuPackage.gtin === null) {
      return '';
    }
    return cuPackage.gtin;
  }

  static getDuGtin(products: PackagedProductGetDTO[]): string {
    const duPackage = products.find(
      (item) =>
        item.pack.type === PACKAGE_TYPES.DISTRIBUTION_UNIT &&
        item.smallerUnit?.pack?.type === PACKAGE_TYPES.CONSUMER_UNIT,
    );
    if (duPackage == null || duPackage.gtin === null) {
      return '';
    }
    return duPackage.gtin;
  }

  static getDisplayGtin(products: PackagedProductGetDTO[]): string {
    const duPackage = products.find(
      (item) =>
        item.pack.type === PACKAGE_TYPES.DISTRIBUTION_UNIT &&
        item.smallerUnit?.pack?.type === PACKAGE_TYPES.CONSUMER_UNIT,
    );
    const displayPackage: PackagedProductGetDTO | undefined = products.find(
      (item) => item.pack.type === PACKAGE_TYPES.DISPLAY,
    );
    if (!displayPackage || duPackage?.gtin) {
      return '';
    }
    return displayPackage.gtin;
  }

  static getLayer(products: PackagedProductGetDTO[]): PackagedProductGetDTO | null {
    const du = ProductService.getDu(products);
    if (!du) {
      return null;
    }
    const layer = products.find((item) => {
      if (item.pack.type === PACKAGE_TYPES.LAYER && item.smallerUnitId === du.id) {
        return item;
      }
      return null;
    });

    return layer ?? null;
  }
}

export default ProductService;
